import { render } from "./AsPushPrompt.vue?vue&type=template&id=0ce6c328&ts=true"
import script from "./AsPushPrompt.vue?vue&type=script&lang=ts"
export * from "./AsPushPrompt.vue?vue&type=script&lang=ts"

import "./AsPushPrompt.vue?vue&type=style&index=0&id=0ce6c328&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__